import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Http from "../../../../commons/utils/Http";
import ButtonAction from "../../../../commons/components/buttonAction";
import AccountTable from "../../../../commons/components/AccountTable";
import TagApplicationRoles from "../../../../commons/components/TagApplicationRoles";
import DataProfile from "./DataProfile";
import PartnerModal from "../PartnerModal/partnerModal";
import UnlinkModal from "../UnlinkModal/unlinkModal";

import {
    usersSetSelectedPartner,
    usersSetModePartnerModal,
    usersSetShowPartnerModal,
    usersSetShowUnlinkModal,
} from '../../../../store/actions/usersActions';
import partnerModalModes from "../PartnerModal/partnerModalModes";

import Permissions from "../../../../commons/utils/permissions";

import { TableActions } from './cardPartnersStyles';

function CardPartners(props) {
    const { screens } = useSelector(state => state.userLogin);
    const { searchPartner, selectedUser, showPartnerModal, showUnlinkModal } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    const [permissions] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);

    const [lineExpand, setLineExpand] = useState(null);

    const defaultPagination = { current: 1, pageSize: 10 };
    const [pagination, setPagination] = useState(defaultPagination);

    const [sorter, setSorter] = useState({ field: "trading_name", order: "ascend" });
    const [filters, setFilters] = useState({});

    const applicationHelpCenterId = 10;

    const tableColumns = [
        {
            title: 'Código',
            dataIndex: 'codparc',
            key: 'codparc',
            width: '5%',
            sorter: true,
        },
        {
            title: 'Parceiro',
            dataIndex: 'trading_name',
            key: 'trading_name',
            sorter: true,
            defaultSortOrder: 'ascend',
        },
        {
            title: 'Aplicações',
            dataIndex: 'applications',
            key: 'applications',
            render: (text, record, index) => (
                <TagApplicationRoles
                    data={text}
                    expand={record.id === lineExpand ? true : false} />
            ),
        },
        {
            title: 'Perfil',
            dataIndex: 'profile',
            key: 'profile',
            render: (text, record, index) => (
                <DataProfile
                    data={text}
                    expand={record.id === lineExpand ? true : false} />
            )
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            ellipsis: true,
            align: "center",
            render: (text, record, index) => (
                <TableActions>
                    <ButtonAction type={record.id === lineExpand ? "view-focused" : "view"} text="Visualizar" callback={() => handleViewPermissions(record)} />

                    {showEditPartner() ?
                        <ButtonAction type="edit" text="Editar Permissões" callback={() => handleEditPartner(record)} />
                        : null
                    }

                    {showUnlinkPartner(text.applications, permissions) ?
                        <ButtonAction type="delete" text="Remover Permissões" callback={() => handleUnlinkPartner(record)} />
                        : null
                    }
                    
                </TableActions>
            ),
        }
    ];

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    useEffect(() => {
        setLineExpand(null);
        getAllOrSearch(pagination, filters, sorter, searchPartner);
    }, [searchPartner]);

    function showEditPartner() {
        const haveEditPartnerPermissions = permissions.find(_function => _function.function_id === Permissions.EDITAR_PERMISSOES_PARCEIRO);

        if (haveEditPartnerPermissions){
            return true;
        }

        return false;
    }

    function showUnlinkPartner(applications, permissions) {
        const haveRemovePermissions = permissions.find(_function => _function.function_id === Permissions.REMOVER_PERMISSOES);
        const haveListRolesHelpCenter = permissions.find(_function => _function.function_id === Permissions.LISTAR_ROLES_CENTRAL_AJUDA);
        const haveApplicationHelpCenter = applications.find(application => application.id == applicationHelpCenterId);

        if (haveRemovePermissions || (haveListRolesHelpCenter && haveApplicationHelpCenter)){
            return true;
        }

        return false;
    }

    function getAllOrSearch(pagination, filters, sorter, search) {
        let filtered = isFiltered(filters);

        if (search === "" && !filtered) {
            getPartnersPermissions(selectedUser.id, pagination, sorter);
        } else {
            searchPartnersPermissions(selectedUser.id, pagination, filters, sorter, search)
        }
    }

    function getPartnersPermissions(user_id, pagination, sorter) {
        const order = getOrder(sorter);
        const offset = pagination.current;
        const lines = pagination.pageSize;

        setTableLoading(true);
        Http.get(`/users/get-partners-permissions?user_id=${user_id}&offset=${offset}&lines=${lines}&order=${order}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    const paginationDescription = (total) => `Parceiros encontrados: ${total}`;
                    setPagination({ ...pagination, total: responseData.pagination, showTotal: paginationDescription });
                    setTableData(responseData.data);
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
                setPagination(defaultPagination);
            })
    }

    function searchPartnersPermissions(user_id, pagination, filters, sorter, search) {
        const body = {
            "user_id": user_id,
            "search": search,
            "offset": pagination.current,
            "lines": pagination.pageSize,
            "order": getOrder(sorter),
            "filters": filters
        };

        setTableLoading(true);
        Http.post(`/users/search-partners-permissions`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    const paginationDescription = (total) => `Usuários encontrados: ${total}`;
                    setPagination({ ...pagination, total: responseData.pagination, showTotal: paginationDescription });
                    setTableData(responseData.data);
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
                setPagination(defaultPagination);
            })
    };

    function isFiltered(filters) {
        let result = false;
        Object.keys(filters).forEach((key) => {
            if (Object.values(filters[key]).length > 0) {
                result = true;
            }
        });
        return result;
    }

    function getOrder(sorter) {
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    }

    function handleViewPermissions(partner) {
        partner.id !== lineExpand ? setLineExpand(partner.id) : setLineExpand(null);
    }

    function handleEditPartner(partner) {
        dispatch(usersSetModePartnerModal(partnerModalModes.EDIT));
        dispatch(usersSetShowPartnerModal(true));
        dispatch(usersSetSelectedPartner(partner));
    }

    function handleUnlinkPartner(partner) {
        dispatch(usersSetShowUnlinkModal(true));
        dispatch(usersSetSelectedPartner(partner));
    }

    function handleOnChangeTable(paginationTable, filtersTable, sorterTable, currentPageData) {
        const mergedFilters = Object.assign(filters, filtersTable);

        Object.keys(mergedFilters).forEach((key) => {
            if (!mergedFilters[key]) {
                delete mergedFilters[key]
            }
        });

        setSorter(sorterTable);
        setFilters(mergedFilters);
        getAllOrSearch(paginationTable, mergedFilters, sorterTable, searchPartner);
    }

    function handleOnSave() {
        getAllOrSearch(pagination, filters, sorter, searchPartner);
    }

    return (
        <>
            <AccountTable
                columns={tableColumns}
                dataSource={tableData}
                pagination={pagination}
                loading={tableLoading}
                onChange={handleOnChangeTable}
            />
            {showPartnerModal ? <PartnerModal onSave={handleOnSave} /> : null}
            {showUnlinkModal ? <UnlinkModal onSave={handleOnSave} /> : null}
        </>
    )
}

export default CardPartners;
